var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2549 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2549 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6626 20.9488C35.6626 18.1187 33.3764 15.8325 30.5463 15.8325H17.4637C14.6336 15.8325 12.3474 18.1187 12.3474 20.9488V27.0318C12.3474 29.8619 14.6336 32.1481 17.4637 32.1481H30.5463C33.3764 32.1481 35.6626 29.8619 35.6626 27.0318V20.9488ZM27.9681 24.4536L22.1065 27.3541C21.8749 27.475 21.0994 27.3139 21.0994 27.052V21.0898C21.0994 20.8279 21.885 20.6567 22.1166 20.7876L27.7364 23.8392C27.958 23.9802 28.1997 24.3227 27.9681 24.4536Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_320",
    x1: 7.0299,
    y1: 7.02415,
    x2: 40.9731,
    y2: 40.9674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8c08180e7bd0a5d720b5c4fa62962e7a.svg";
export { ForwardRef as ReactComponent };